export default __webpack_public_path__ + "static/media/hunger2.3866026d.png";